/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { School } from '../../models/school';

export interface CreateSchool$Params {
      body?: School
}

export function createSchool(http: HttpClient, rootUrl: string, params?: CreateSchool$Params, context?: HttpContext): Observable<StrictHttpResponse<School>> {
  const rb = new RequestBuilder(rootUrl, createSchool.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<School>;
    })
  );
}

createSchool.PATH = '/school';
